import React, { useRef, useState } from "react";
import ReactPlayer from "react-player";

const AVReactPlayer = (props) => {
    const playerRef = useRef(null);
    const [videoUrl, setVideoUrl] = useState("");

    let videoWidth = "1000px"; // Default video width

    const screenWidth = window.innerWidth;
    if (screenWidth < 400) {
        // Mobile screen
        videoWidth = "320px";
    } else if (screenWidth < 768) {
        // Mobile screen
        videoWidth = "600px";
    } else if (screenWidth < 1024) {
        // Tablet screen
        videoWidth = "800px";
    }

    const handleProgress = ({ playedSeconds }) => {
        /* console.log('Current time:', playedSeconds); */
        /* props.onCurrentTimeChange(playedSeconds); */
    };

    const handleDuration = (duration) => {
        if (props.setPlayer) {
            props.setPlayer({
                ...props.playerSlice,
                duration: duration,
            });
            playerRef.current.seekTo(props.playerSlice.played);
        }
    };

    return (
        <div className="flex justify-center items-center h-full">
            <div
                style={{
                    width: videoWidth,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <ReactPlayer
                    ref={playerRef}
                    url={props.videoUrl}
                    controls
                    width="90%"
                    height="auto"
                    onProgress={handleProgress}
                    onSeek={handleDuration}
                />
            </div>
        </div>
    );
};

export default AVReactPlayer;
